import {createContext} from "react";


export const ScaleContext= createContext<number>(1)
